module.exports = __webpack_public_path__ + "media/images/pic/rewards_default-f863f33f59d90ed048aeddcf08a3022e.svg";